import React from "react";

class PUFAIntro extends React.Component {
  render() {
    return (
      <div>
        <div className="title-margins">
          <h2>
            Introduction to Omega-3 Polyunsaturated Fatty Acids
          </h2>
        </div>

        <div className="title-break">
          <span>Overview</span>
        </div>

        <div className="card">
          <img
            alt="Foods containing omega-3 polyunsaturated fatty acids"
            className="overview-img"
            src="/assets/imgs/results/content/PUFA.jpeg"
            height={200}
          />

          <p>
            Omega-3 polyunsaturated fatty acids (PUFAs) are nutrients
            obtained from food or supplements. They have many beneficial
            effects, including reducing triglycerides, improving heart
            health, and alleviating chronic inflammation. There are four
            types of omega-3 PUFAs: ALA, EPA, DPA, and DHA. ALA is found
            in plant sources such as nuts and seeds, while the other three
            are primarily found in certain fish.
          </p>

          <p>
            Many studies show that eating fatty fish and other types of
            seafood as part of a healthy eating pattern helps keep your
            heart healthy. Getting more omega-3 PUFAs from food or dietary
            supplements can also lower triglyceride levels. The American
            Heart Association recommends eating one to two servings of
            seafood per week to reduce the risk of certain heart problems,
            especially when seafood replaces less healthy foods.
          </p>
        </div>

        <div className="title-break">
          <span>Benefits of omega-3 PUFAs</span>
        </div>

        <div className="card">
          <p>The benefits of omega-3 PUFAs include:</p>

          <p>
            <strong>Triglycerides and HDL.</strong> Omega-3 PUFAs can
            increase levels of “good” HDL and cause a large reduction
            (15–30%) in triglyceride levels. Higher levels of HDL and
            lower levels of triglycerides are beneficial because they can
            reduce the risk of heart disease and stroke.
          </p>

          <p>
            <strong>Chronic inflammation.</strong> Chronic inflammation
            persists even without an infection or injury. It contributes
            to many chronic diseases, including heart disease, diabetes,
            and cancer. Omega-3 PUFAs may reduce the production of
            substances associated with chronic inflammation, including
            inflammatory eicosanoids and cytokines.
          </p>

          <p>
            <strong>Rheumatoid arthritis (RA).</strong> RA can cause
            chronic pain, swelling, stiffness, and loss of function in the
            joints. Omega-3 supplements may help manage RA when taken with
            standard medications and other treatments. They may also
            improve the effectiveness of anti-inflammatory drugs.
          </p>
        </div>

        <div className="title-break">
          <span>Sources of omega-3 PUFAs</span>
        </div>

        <div className="card">
          <p>
            You can get adequate amounts of omega-3 PUFAs from a variety
            of foods, including:
          </p>

          <ul style={{ listStyleType: "square" }}>
            <li>
              Fish and other seafood, such as salmon, tuna, herring, and
              sardines
            </li>
            <li>
              Nuts and seeds, such as flaxseed, chia seeds, and walnuts
            </li>
            <li>
              Plant oils, such as flaxseed oil, soybean oil, and canola oil
            </li>
            <li>
              Fortified foods, such as certain brands of eggs, yogurt,
              juice, milk, and soy beverages
            </li>
          </ul>
        </div>

        <div className="title-break">
          <span>
            Most people have sufficient levels of omega-3 PUFAs
          </span>
        </div>

        <div className="card">
          <p>
            Most people in the United States get enough omega-3 PUFAs from
            the foods they eat. Recommended amounts of EPA and DHA have
            not been established. An omega-3 deficiency can cause rough,
            scaly skin and a red, swollen, itchy rash.
          </p>
        </div>
      </div>
    );
  }
}

export default PUFAIntro;